import React from 'react'
import './index.less'
import {URL_CY_HELP} from "../../../../constants/CyHomepage";

const clsPrefix = 'c-practice-item-card'
const PracticeItemCard: React.FC<{
  title: string[],
  imgUrl?: string,
  url?: string,
}> = ({
  title = [],
  imgUrl = '',
  url = '',
}) => {
  return (
    <div className={clsPrefix}>
      {/*<img src={imgUrl} className={`${clsPrefix}__image`} alt='' />*/}
      <div className={`${clsPrefix}__content`}>
          <div className={`${clsPrefix}__labImage`}>
              <img className="labImg" src={imgUrl} />
          </div>
          <div className={`${clsPrefix}__title`}>
              {
                  title && title.map((text,index) => (
                      <p key={index}>{text}</p>
                  ))
              }
              <div className={`${clsPrefix}__pra__line`}></div>
              <a className='labLink' href= {`${URL_CY_HELP}${url}`} target="_blank">立即体验</a>
          </div>
      </div>
    </div>
  )
}

export { PracticeItemCard }
